"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));

var _OptionItem = _interopRequireDefault(require("./OptionItem"));

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Option =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Option, _React$PureComponent);

  function Option(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Option);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Option).call(this, props));

    _this.handleSelect = function (e) {
      if (_this.props.onSelect) {
        _this.props.onSelect(e, _objectSpread({}, _this.props, {
          text: _this.state.propText,
          hint: _this.state.hintText
        }));
      }
    };

    _this.handleMouseEnter = function () {
      if (_this.props.setSelectedIndex) {
        _this.props.setSelectedIndex(_this.props.itemIndex || 0);
      }
    };

    _this.handleMouseOut = function () {
      if (_this.props.setSelectedIndex) {
        _this.props.setSelectedIndex(-1);
      }
    };

    var hint = props.hint,
        text = props.text,
        children = props.children;
    var hintText = hint || '';
    var propText = text || '';

    if (!text && typeof children === 'string') {
      propText = children;
    }

    if (!hint && typeof children === 'string') {
      hintText = propText;
    }

    _this.state = {
      propText: propText,
      hintText: hintText
    };
    return _this;
  }

  (0, _createClass2.default)(Option, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.setDefaultOption && this.props.selectedIndex === this.props.itemIndex) {
        this.props.setDefaultOption(_objectSpread({}, this.props, {
          text: this.state.propText,
          hint: this.state.hintText
        }));
      }
    } // eslint-disable-next-line react/no-deprecated

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (this.props.setDefaultOption && newProps.itemIndex === newProps.selectedIndex) {
        this.props.setDefaultOption(_objectSpread({}, newProps, {
          text: this.state.propText,
          hint: this.state.hintText
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$isSelecte = _this$props.isSelected,
          isSelected = _this$props$isSelecte === void 0 ? false : _this$props$isSelecte,
          children = _this$props.children,
          onSelect = _this$props.onSelect,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["isSelected", "children", "onSelect"]);
      return (0, _core.jsx)(_OptionItem.default, (0, _extends2.default)({
        isSelected: isSelected,
        onClick: this.handleSelect,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseOut
      }, rest), children, isSelected && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_VisuallyHidden.default, null, this.props.ariaLabelSelected), (0, _core.jsx)(_Icon.default, {
        name: "singlecheck",
        color: "core1_100",
        size: "xsmall",
        "aria-hidden": true
      })));
    }
  }]);
  return Option;
}(_react.default.PureComponent);

var _default = Option;
exports.default = _default;